import PropTypes from "prop-types";
import FulfilmentInformationIcon from "../../../containers/common/FulfilmentInformationIcon";
import FulfilmentStringsMarkup from "../FulfilmentStringsMarkup";
import getFulfilmentIds from "../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../getFulfilmentType";

const { CORE_NON_PRIMARY } = FULFILMENT_TYPE;

const FulfilmentMarkup = ({
  labelledById,
  seller,
  source,
  productId,
  variantId
}) => {
  const { sellerId, sourceId } = getFulfilmentIds({ source, seller });
  const fulfilmentType = getFulfilmentType({ sellerId, sourceId });

  if (fulfilmentType === CORE_NON_PRIMARY) {
    return (
      <FulfilmentStringsMarkup
        labelledById={labelledById}
        source={source}
        seller={seller}
      />
    );
  }

  return (
    <FulfilmentInformationIcon
      seller={seller}
      source={source}
      productId={productId}
      variantId={variantId}
    >
      <FulfilmentStringsMarkup
        labelledById={labelledById}
        source={source}
        seller={seller}
      />
    </FulfilmentInformationIcon>
  );
};

FulfilmentMarkup.propTypes = {
  labelledById: PropTypes.string.isRequired,
  source: PropTypes.shape({
    description: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  }),
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  }),
  productId: PropTypes.number.isRequired,
  variantId: PropTypes.number
};

export default FulfilmentMarkup;
